var _g, _g2, _g3, _g4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoWorklists = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 78,
  height: 86,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_worklists_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 52.319,
  x: 16.424,
  y: 12.955,
  fill: "url(#no_worklists_svg__b)",
  rx: 3.818
}), /*#__PURE__*/React.createElement("rect", {
  width: 47.545,
  height: 54.864,
  x: 15.152,
  y: 11.682,
  stroke: "#fff",
  strokeWidth: 2.545,
  rx: 5.09
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_worklists_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.43,
  height: 26.047,
  x: 24.537,
  y: 31.174,
  fill: "#fff",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.43,
  height: 26.047,
  x: 24.537,
  y: 31.174,
  stroke: "#fff",
  strokeWidth: 2.545,
  rx: 2
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_worklists_svg__d)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.43,
  height: 26.047,
  x: 28.867,
  y: 27.102,
  fill: "url(#no_worklists_svg__e)",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.43,
  height: 26.047,
  x: 28.867,
  y: 27.102,
  stroke: "#fff",
  strokeWidth: 2.545,
  rx: 3
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_worklists_svg__f)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.689,
  height: 15.689,
  x: 39.624,
  y: 21.007,
  fill: "url(#no_worklists_svg__g)",
  rx: 1.883
}), /*#__PURE__*/React.createElement("rect", {
  width: 15.689,
  height: 15.689,
  x: 39.624,
  y: 21.007,
  stroke: "#867AF2",
  strokeWidth: 2.5,
  rx: 1.883
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M44.033 28.852h6.87M47.468 25.416v6.871"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "no_worklists_svg__a",
  width: 77.849,
  height: 85.168,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.47
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1249"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1249",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_worklists_svg__c",
  width: 51.733,
  height: 56.351,
  x: 9.385,
  y: 19.492,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.47
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1249"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1249",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_worklists_svg__d",
  width: 51.733,
  height: 56.351,
  x: 13.716,
  y: 15.42,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.47
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1249"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1249",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_worklists_svg__f",
  width: 31.878,
  height: 31.878,
  x: 31.529,
  y: 14.624,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.711
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.422
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1249"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1249",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_worklists_svg__b",
  x1: 16.424,
  x2: 61.424,
  y1: 39.114,
  y2: 39.114,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_worklists_svg__e",
  x1: 28.867,
  x2: 50.297,
  y1: 40.125,
  y2: 40.125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_worklists_svg__g",
  x1: 39.624,
  x2: 55.312,
  y1: 28.852,
  y2: 28.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})))));
export default SvgNoWorklists;